// apps/spa/src/hooks/useEvents.ts
// TanStack Query wrapper for GET /api/events.
//
// Returns upcoming BASTN scheduled events from the worker's events_cache table.
// Until Phase 6 ships the event-sync cron, the worker returns [] — the SPA
// handles that gracefully (ScheduleEditor disables the Specific event radio).
//
// staleTime 5 * 60 * 1000 matches the worker's KV cache TTL (5 minutes).

import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export type GuildScheduledEvent = {
  id: string;
  name: string;
  scheduledStartTime: number;
  channelId: string | null;
};

export function useEvents() {
  return useQuery({
    queryKey: ['events'] as const,
    queryFn: () => api<GuildScheduledEvent[]>('/api/events'),
    staleTime: 5 * 60 * 1000,
  });
}
